document.addEventListener("DOMContentLoaded", function () {
  const sections = document.querySelectorAll(".collection-bubbles");

  sections.forEach((section) => {
    const wrapper = section.querySelector(".bubbles-wrapper");
    const grid = wrapper.querySelector(".bubbles-grid");
    const dotsContainer = wrapper.querySelector(".bubbles-dots");
    const prevBtn = wrapper.querySelector(".bubbles-prev");
    const nextBtn = wrapper.querySelector(".bubbles-next");

    const sliderEnabled = wrapper.dataset.sliderMobile === "true";
    if (!sliderEnabled) return;

    const blockCount = grid.children.length;
    const itemsPerView = parseInt(wrapper.dataset.visibleItems) || 1;
    const autoScrollInterval = parseInt(wrapper.dataset.autoplay) * 1000 || 0;
    const autoEnabled = wrapper.dataset.autoEnabled === "true";
    const autoDirection = wrapper.dataset.autoDirection || "right";
    const showDots = wrapper.dataset.dots === "true";
    const showArrows = wrapper.dataset.arrows === "true";

    let currentIndex = 0;
    const maxIndex = Math.max(0, blockCount - itemsPerView);

    function scrollToIndex(index) {
      const bubble = grid.children[index];
      if (bubble) {
        const scrollX = bubble.offsetLeft;
        grid.scrollTo({ left: scrollX, behavior: "smooth" });
      }
      updateDots();
    }

    function updateDots() {
      if (!showDots || !dotsContainer) return;
      dotsContainer.innerHTML = "";
      for (let i = 0; i <= maxIndex; i++) {
        const dot = document.createElement("div");
        dot.className = "dot" + (i === currentIndex ? " active" : "");
        dot.addEventListener("click", () => {
          currentIndex = i;
          scrollToIndex(currentIndex);
        });
        dotsContainer.appendChild(dot);
      }
      dotsContainer.setAttribute("aria-hidden", "false");
    }

    if (showArrows && prevBtn && nextBtn) {
      prevBtn.addEventListener("click", () => {
        if (currentIndex > 0) currentIndex--;
        scrollToIndex(currentIndex);
      });

      nextBtn.addEventListener("click", () => {
        if (currentIndex < maxIndex) currentIndex++;
        scrollToIndex(currentIndex);
      });

      prevBtn.parentElement.setAttribute("aria-hidden", "false");
    }

    updateDots();

    // Detecta swipe manual e atualiza os dots
    grid.addEventListener("scroll", () => {
      const scrollLeft = grid.scrollLeft;
      const itemWidth = grid.scrollWidth / grid.children.length;
      const newIndex = Math.round(scrollLeft / itemWidth);
      if (newIndex !== currentIndex) {
        currentIndex = newIndex;
        updateDots();
      }
    });

    // Auto scroll com direção
    if (autoEnabled && autoScrollInterval > 0) {
      setInterval(() => {
        if (autoDirection === "right") {
          currentIndex = currentIndex < maxIndex ? currentIndex + 1 : 0;
        } else {
          currentIndex = currentIndex > 0 ? currentIndex - 1 : maxIndex;
        }
        scrollToIndex(currentIndex);
      }, autoScrollInterval);
    }
  });
});